export default __webpack_public_path__ + "static/media/marsha.eac4a7f9.png";